"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
// To prevents extra re-renders caused by useSelector hook this method deeply compaire store objects using lodash isEqual
// https://react-redux.js.org/api/hooks#stale-props-and-zombie-children
var useShallowEqualSelector = function (selector) {
    return react_redux_1.useSelector(selector, lodash_isequal_1.default);
};
exports.default = useShallowEqualSelector;
//# sourceMappingURL=useSelector.js.map